/* tslint:disable:object-literal-sort-keys jsx-no-lambda */
import React from "react";
import { Redirect } from "react-router-dom";
import { BrowserView, isDesktop, MobileView } from "react-device-detect";
import queryString from "query-string";
import classNames from "classnames";

import Row from "antd/es/row";
import Col from "antd/es/col";
import Typography from "antd/es/typography";

import { history } from "src/ipm-shared/store";

import ROUTES from "src/bepaid/routes";
import Button from "src/bepaid/components/Form/controls/Button";
import Image from "src/bepaid/components/Image";
import useQuery from "src/bepaid/hooks/useQuery";
import { purposeByEntity } from "src/bepaid/pages/Payments/const";
import { typeByEntity } from "src/bepaid/utils/recipient";

import Skeleton from "src/bepaid/components/Skeleton";
import FilterTags from "src/bepaid/components/FilterTags";
import MainLayout from "src/bepaid/layouts/MainLayout";
import ProfileHeading from "src/bepaid/layouts/MainLayout/components/ProfileHeading";
import ButtonsHeading from "src/bepaid/layouts/MainLayout/components/ButtonsHeading";
import Pagination from "src/bepaid/components/Pagination";

import CustomerSearch from "src/bepaid/assets/images/customers/customers_search.svg";
import CustomerFilter from "src/bepaid/assets/images/customers/customers_filter.svg";
import CustomerAvatar from "src/bepaid/assets/images/customers/customers_avatar.svg";
import NextIcon from "src/bepaid/assets/images/common/desktop/next_black_noborder.svg";

import RecipientsSearchAndFilter from "../components/RecipientsSearchAndFilter";
import OverviewBoxs from "../components/OverviewBoxs";
import CardDetails from "../components/CardDetails/View";

import { useMakePayeeUrlParams } from "../hooks";
import { PAYEES_PAGE_COUNT } from "src/ipm-shared/store/model/Payee/const";
import styles from "../Recipients.module.scss";
import Tab from "src/bepaid/components/Tabs";
import FeatureGateUtil from "src/ipm-shared/components/FeatureGating/Util";
import { SUPPLIER_PAYOUT_TYPES } from "src/ipm-shared/store/model/PaymentRequest/const";

const initPagination = {
  offset: 0,
  pageCount: PAYEES_PAGE_COUNT
};

const optionSwitch = {
  bank_account: {
    label: "Bank Account",
    defaultFilter: {
      supplierPayoutType: SUPPLIER_PAYOUT_TYPES.BANK_ACCOUNT
    },
    value: SUPPLIER_PAYOUT_TYPES.BANK_ACCOUNT
  },
  uen: {
    label: "UEN",
    defaultFilter: {
      supplierPayoutType: SUPPLIER_PAYOUT_TYPES.UEN
    },
    value: SUPPLIER_PAYOUT_TYPES.UEN
  }
};

const View: React.FC<any> = props => {
  const {
    hasToken,
    list,
    // shouldDisplayLoadingPayees,
    hasWallexPayment,
    total,
    shouldDisplayLoadingDashboard
  } = props;
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState(initPagination);

  const qs = useQuery();
  const { replaceRouteWithParams } = useMakePayeeUrlParams();
  const purpose = purposeByEntity[typeByEntity.employees];

  const isBankAccount =
    qs.supplierPayoutType === SUPPLIER_PAYOUT_TYPES.BANK_ACCOUNT;

  React.useEffect(() => {
    if (qs.supplierPayoutType) {
      props.setSupplierPayoutType(qs.supplierPayoutType);
    }
  }, [qs.supplierPayoutType]);

  const handleSetNewQuery = (newQuery: any) => {
    history.push(
      `${ROUTES.RECIPIENTS_SUPPLIERS}/?${queryString.stringify(newQuery || {})}`
    );
  };

  const handleOpenDetail = (payeeId: number) => {
    const search = new URLSearchParams(history.location.search);

    const url =
      `${ROUTES.RECIPIENTS_SUPPLIERS}/${payeeId}` + "?" + search.toString();

    history.push(url, {
      prevRoute: replaceRouteWithParams(ROUTES.RECIPIENTS_DETAILS, {
        newEntity: "suppliers"
      })
    });
  };

  const handleChangeTab = (idx: number) => {
    handleSetNewQuery(Object.values(optionSwitch)[idx].defaultFilter);
    setPagination(initPagination);
  };

  const shouldFetchData = !(props.isBgOfPopup && props.isFirstFetchData);

  const handleOnChangePage = (offset: number) => {
    setPagination({ ...pagination, offset });
  };

  const listSuppliers = () => {
    return (
      <Skeleton loading={loading && shouldFetchData}>
        <Row className={styles.listWrapper}>
          {list.length > 0 ? (
            list.map((item: any) => (
              <Col key={item.id} span={24}>
                <CardDetails
                  icon={CustomerAvatar}
                  id={item.id}
                  title={item.name}
                  description={item.registrationNumber}
                  bankCountryId={
                    hasWallexPayment ? item.international.bankCountryId : null
                  }
                  onClick={() => handleOpenDetail(item.id)}
                  // onOpenTagDrawer={handleOpenCustomerTagDrawer}
                />
              </Col>
            ))
          ) : (
            <div className={styles.noResults}>
              <Typography.Text>No results found.</Typography.Text>
            </div>
          )}
        </Row>
      </Skeleton>
    );
  };

  const tabs = Object.values(optionSwitch).map((item: any, idx: number) => ({
    name: item.label,
    content: listSuppliers()
  }));

  const renderContent = () => {
    return (
      <div
        className={classNames(styles.wrapper, {
          [styles.desktop]: isDesktop
        })}
      >
        <div className={styles.container}>
          <div className={styles.overviewBoxWrapper}>
            <OverviewBoxs isBgOfPopup={props.isBgOfPopup} />
          </div>

          <Skeleton loading={shouldDisplayLoadingDashboard}>
            <div className={styles.tabWrapper}>
              <Skeleton
                loading={loading && shouldFetchData}
                paragraph={{ rows: 1 }}
              >
                <FilterTags
                  type="customers"
                  handleSetNewQuery={handleSetNewQuery}
                />
              </Skeleton>
              {FeatureGateUtil.verifyFeature(
                props.features,
                "PAY_TO_UEN_FLOW"
              ) ? (
                <Tab
                  tabs={tabs}
                  onChange={handleChangeTab}
                  defaultActiveKey={isBankAccount ? "1" : "2"}
                  extraMarginRight={true}
                />
              ) : (
                <>{listSuppliers()}</>
              )}

              <Skeleton
                loading={loading && shouldFetchData}
                paragraph={{ rows: 1 }}
              >
                <Pagination
                  customClassname={styles.paginationWrapper}
                  defaultMode={true}
                  hideOnSinglePage={true}
                  showSizeChanger={false}
                  showLessItems={true}
                  total={total}
                  showQuickJumper={
                    total / pagination.pageCount > 10 && {
                      goButton: (
                        <button className={styles.gotoButton}>
                          <b>
                            Go
                            <Image src={NextIcon} className={styles.gotoIcon} />
                          </b>
                        </button>
                      )
                    }
                  }
                  locale={{ jump_to: "Go to page" }}
                  isDisableToggle={total / pagination.pageCount < 5}
                  onChange={handleOnChangePage}
                  {...pagination}
                />
              </Skeleton>
            </div>
          </Skeleton>
        </div>
      </div>
    );
  };

  const renderDesktopView = () => {
    return (
      <MainLayout
        header={{
          leftHeader: <ProfileHeading />,
          rightHeader: (
            <ButtonsHeading type={"recipients"} recipientPath={"suppliers"} />
          )
        }}
        body={{
          leftBody: renderContent(),
          rightBody: <RecipientsSearchAndFilter recipientPath={"suppliers"} />
        }}
      />
    );
  };

  const renderMobileView = () => {
    const handleCreateNewSupplier = () => {
      history.push(
        FeatureGateUtil.verifyFeature(props.features, "PAY_TO_UEN_FLOW")
          ? ROUTES.RECIPIENTS_SUPPLIER_SELECT_TYPE
          : ROUTES.RECIPIENTS_SUPPLIERS_CREATE
      );
    };
    return (
      <MainLayout
        header={{
          title: "Suppliers",
          onBack: () => history.push(ROUTES.ROOT),
          rightIcons: (
            <>
              <Image
                src={CustomerSearch}
                className={styles.icon}
                onClick={() => {
                  const urlParams = new URLSearchParams(window.location.search);
                  urlParams.set("key", "suppliers");
                  history.push({
                    pathname: `${ROUTES.SEARCH}`,
                    search: "?" + urlParams.toString()
                  });
                }}
              />
              <Image
                src={CustomerFilter}
                className={styles.icon}
                onClick={() => {
                  const urlParams = new URLSearchParams(window.location.search);
                  urlParams.set("key", "suppliers");
                  history.push({
                    pathname: `${ROUTES.FILTER}`,
                    search: "?" + urlParams.toString()
                  });
                }}
              />
            </>
          ),
          hasBorder: false
        }}
        footer={
          <Button
            type="primary"
            htmlType="button"
            onClick={handleCreateNewSupplier}
          >
            Add supplier
          </Button>
        }
      >
        {renderContent()}
      </MainLayout>
    );
  };

  React.useEffect(() => {
    if (
      !props.isBgOfPopup &&
      !window.location.search.includes("?") &&
      !Boolean(/^\/suppliers\/.+$/.test(window.location.pathname))
    ) {
      const defaultFilter = {
        supplierPayoutType: SUPPLIER_PAYOUT_TYPES.BANK_ACCOUNT
      };

      history.push(
        `${window.location.pathname}?${queryString.stringify(defaultFilter)}`
      );
    }
  }, [props.isBgOfPopup]);

  const fetchListData = () => {
    props.fetchPayees({
      type: "invoice",
      offset: pagination.offset,
      pageCount: pagination.pageCount,
      getAllPayees: true,
      noRedirect: true,
      loadingFunc: setLoading
    });
  };

  React.useEffect(() => {
    if (!shouldFetchData) {
      return;
    }
    props.selectPayees({
      ids: [],
      purpose,
      removedIds: "all"
    });
    fetchListData();
  }, [pagination]);

  React.useEffect(() => {
    if (!shouldFetchData) {
      return;
    }
    // fetchListData();
    return () => {
      setPagination(JSON.parse(JSON.stringify(initPagination)));
    };
  }, [
    qs.from,
    qs.to,
    qs.search_keyword,
    qs.dateQueryKey,
    qs.supplierPayoutType
  ]);

  return !hasToken ? (
    <Redirect to={ROUTES.LOGIN_REDIRECT} />
  ) : (
    <>
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>{renderMobileView()}</MobileView>
    </>
  );
};

export default View;
